export const MODAL_TYPE_REPORT_COMMENT = 'report-comment';
